import { getAxiosInstance } from "../utils/apiClient";
import { getTokens } from "../utils/tokens";

const axiosInstance = getAxiosInstance();

// Get all transactions with filtering and pagination
export const getTransactionsAPI = (filters = {}) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/transactions", {
                params: filters,
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get transaction by ID
export const getTransactionByIdAPI = (transactionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get(`/api/transactions/${transactionId}`, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Create new transaction
export const createTransactionAPI = (transactionData) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post("/api/transactions", transactionData, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Mark transaction as completed
export const markTransactionCompletedAPI = (transactionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/transactions/${transactionId}/complete`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Mark transaction as failed
export const markTransactionFailedAPI = (transactionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/transactions/${transactionId}/fail`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Refund transaction
export const refundTransactionAPI = (transactionId) => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .post(`/api/transactions/${transactionId}/refund`, {}, {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};

// Get transaction statistics
export const getTransactionStatsAPI = () => {
    return new Promise((resolve, reject) => {
        const tokens = getTokens();
        axiosInstance
            .get("/api/transactions/stats/user", {
                headers: {
                    "Content-Type": "application/json",
                    [process.env.REACT_APP_AUTH_TOKEN]: `Bearer ${tokens.access_token}`,
                    [process.env.REACT_APP_FIREBASE_AUTH_TOKEN]:
                        `Bearer ${tokens.firebase_token}`,
                    "ngrok-skip-browser-warning": "true",
                },
            })
            .then((res) => resolve(res.data))
            .catch((err) => reject(err?.response?.data || err));
    });
};
